<div class="d-flex w-100 h-100 justify-content-between">
  <div
    class="lcl-header-detailed-info"
    [ngClass]="{
      'shipment-dashboard-template': template === enumDetailedInfoPlacementEnum.shipmentDashboardTemplate,
      'quote-dashboard-template': template === enumDetailedInfoPlacementEnum.quoteDashboardTemplate,
      'header-template': template === enumDetailedInfoPlacementEnum.quoteTemplate,
      'quote-template': template === enumDetailedInfoPlacementEnum.quoteTemplate,
      'with-insurance': isShowInsuranceIndicator
    }"
  >
    <div class="lcl-header-detailed-info-reference" *ngIf="!!referenceValue">
      <p>{{ referenceName | translate }}</p>
      <h4 [ngClass]="{ 'f-s-14': isDashboardPlacement }">{{ referenceValue }}</h4>
    </div>

    <div class="lcl-header-detailed-info-icon">
      <img src="assets/icons/icon_vessel.svg" />
      <span>{{ "MENU.LCL" | translate }}</span>
    </div>

    <div class="lcl-header-detailed-info-from-to" [ngStyle]="{ flex: isDashboardPlacement ? 'inherit' : 8 }">
      <div class="row" *ngIf="!isQuote">
        <div class="col-5">
          <p>{{ "LABELS.FROM" | translate }}</p>
          <h4 [title]="fromPortLabel" [innerHTML]="sanitizer.bypassSecurityTrustHtml(fromPortHtmlLabel)"></h4>
        </div>
        <div class="col-2 my-auto d-flex justify-content-center">
          <span class="lcl-header-detailed-info-from-to-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="currentColor">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.500001 9L12.7 9L7.1 14.6L8.5 16L16.5 8L8.5 -6.99382e-07L7.1 1.4L12.7 7L0.500001 7L0.500001 9Z"
                fill="black"
              />
            </svg>
          </span>
        </div>
        <div class="col-5">
          <p>{{ "LABELS.TO" | translate }}</p>
          <h4 [title]="toPortLabel" [innerHTML]="sanitizer.bypassSecurityTrustHtml(toPortHtmlLabel)"></h4>
        </div>
      </div>
      <div class="dashboard-placement" *ngIf="isQuote">
        <div class="icon-container">
          <span class="lcl-header-detailed-info-from-to-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="currentColor">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.500001 9L12.7 9L7.1 14.6L8.5 16L16.5 8L8.5 -6.99382e-07L7.1 1.4L12.7 7L0.500001 7L0.500001 9Z"
                fill="black"
              />
            </svg>
          </span>
        </div>
        <div class="destinations-container">
          <div class="destinations-container__item">
            <p>{{ "LABELS.FROM" | translate }}</p>
            <h4 [innerHTML]="sanitizer.bypassSecurityTrustHtml(fromPortHtmlLabel)"></h4>
          </div>
          <div class="destinations-container__item">
            <p>{{ "LABELS.TO" | translate }}</p>
            <h4 [innerHTML]="sanitizer.bypassSecurityTrustHtml(toPortHtmlLabel)"></h4>
          </div>
        </div>
      </div>
    </div>

    <div class="lcl-header-detailed-info-service-type" [ngStyle]="{ flex: isDashboardPlacement ? 'inherit' : 4 }">
      <p>{{ "LABELS.SERVICE_TYPE" | translate }}</p>
      <h4 [ngClass]="{ 'f-s-14': isDashboardPlacement }">{{ "LCL_SHIPMENT.QUOTE.CREATE.PORT_TO_PORT" | translate }}</h4>
    </div>
    <div class="lcl-header-detailed-info-incoterms" [ngStyle]="{ flex: isDashboardPlacement ? 'inherit' : 1 }" *ngIf="isShowIncoterms">
      <p>{{ "LABELS.INCOTERMS" | translate }}</p>

      <div class="lcl-header-detailed-info-incoterms-label" [ngClass]="{ 'f-s-14': isDashboardPlacement }" *ngIf="info?.incoTermsType">
        {{ "LABELS." + enumIncotermsType[info?.incoTermsType] + "_LABEL" | translate }}
      </div>
      <img src="assets/icons/edit_gray.svg" *ngIf="isShowEditIncoterms" (click)="onEditIncoTerms()" />
    </div>

    <div class="lcl-header-detailed-info-insurance" *ngIf="isShowInsuranceIndicator">
      <app-marine-insurance-indicator
        [isOnEntityPage]="true"
        [companyPlacement]="enumCompanyPlacement.SHIPMENT"
        [entityReferenceNumber]="shipment.referenceNumber"
        [entityStatus]="shipment.insuranceStatus"
        [isDisabled]="isInsuranceBlocked"
        [disabledTooltipKey]="insuranceBlockTooltipKey"
        (addInsurance)="onAddInsurance()"
      ></app-marine-insurance-indicator>
    </div>
  </div>
  <ng-content></ng-content>
</div>
